<script setup lang="ts">
  interface SegmentOption {
    value: string
    label: string
    icon?: any
  }

  interface Props {
    options: SegmentOption[]
    value: string
    class?: string
  }

  const props = defineProps<Props>()

  const emit = defineEmits<{
    'update:value': [value: string]
  }>()

  const handleValueChange = (newValue: string) => {
    emit('update:value', newValue)
  }
</script>

<template>
  <div
    class="relative box-border flex size-full content-stretch items-center gap-1 rounded-lg bg-gray-100 p-1"
    :class="props.class"
  >
    <div
      aria-hidden="true"
      class="pointer-events-none absolute inset-0 rounded-lg border border-solid border-gray-200"
    />
    <button
      v-for="option in props.options"
      :key="option.value"
      class="relative flex h-6 min-h-px min-w-px shrink-0 grow basis-0 items-center justify-center overflow-clip
        rounded-md p-1.5 transition-all duration-200"
      :class="
        props.value === option.value
          ? 'bg-white shadow-[0px_2px_4px_0px_rgba(0,0,0,0.04)]'
          : 'hover:bg-gray-50'
      "
      :aria-pressed="props.value === option.value"
      :data-cy="`segment-switch-${option.value}`"
      @click="handleValueChange(option.value)"
    >
      <div
        class="relative box-border flex shrink-0 content-stretch items-center justify-center gap-1.5 px-1.5 py-0"
      >
        <component
          :is="option.icon"
          v-if="option.icon"
          class="h-4 w-4"
        />
        <div
          class="leading-0 relative shrink-0 text-nowrap text-sm font-medium not-italic text-gray-800"
        >
          <p class="whitespace-pre leading-5">{{ option.label }}</p>
        </div>
      </div>
    </button>
  </div>
</template>
